
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
var redirectURL = require('../redirectURL');
const AddDealerConsignments = (props) => {
    const handleRouteClick = (e) => {
        e.stopPropagation();
         props.onClickActive(props);
    };
    return (
        <div>
        <button onClick={handleRouteClick} className="btn btn-danger custom-btn f12 label label-success" 
        title="Add Dealer" >Add Dealer</button>
        
    </div>
);
    
};
export default AddDealerConsignments;
